<h2 *ngIf="loading">Loading ..</h2>